module.exports = __webpack_public_path__ + "static/media/30 sq m.da9c3fa3.JPG";